import React, { useState } from "react";
import { Archive, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import api, { fmtEur } from "../lib/api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const meseLabel = (m) => { if (!m || !m.includes("-")) return m || "—"; const [y, mm] = m.split("-"); return `${MESI[+mm - 1] || mm} ${y}`; };

export default function BusteArchivioButton() {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const { data: archived = [] } = useQuery({
    queryKey: ["buste-archivio"],
    queryFn: async () => (await api.get("/buste_paga/archivio")).data,
    enabled: open,
  });
  const restore = async (id) => {
    try {
      await api.post(`/buste_paga/${id}/restore`);
      qc.invalidateQueries({ queryKey: ["buste-archivio"] });
      qc.invalidateQueries({ queryKey: ["buste_paga"] });
      qc.invalidateQueries({ queryKey: ["buste_paga_mese"] });
      toast.success("Busta ripristinata");
    } catch { toast.error("Errore ripristino"); }
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="buste-archivio-btn">
        <Archive size={15} className="mr-1.5" /> Archivio
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" data-testid="buste-archivio-dialog">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><Archive size={18} /> Archivio buste paga</DialogTitle></DialogHeader>
          <div className="max-h-[60vh] overflow-auto">
            {archived.length === 0 ? (
              <div className="py-8 text-center text-sm text-muted-foreground" data-testid="buste-archivio-empty">Nessuna busta in archivio.</div>
            ) : (
              <div className="divide-y">
                {archived.map((b) => (
                  <div key={b.id} className="flex items-center gap-3 py-2" data-testid={`buste-arch-row-${b.id}`}>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-semibold truncate">{b.operatore_nome || "(senza nome)"}</div>
                      <div className="text-xs text-muted-foreground">{meseLabel(b.mese)} · netto {fmtEur(b.netto)}{b.eliminato_motivo ? ` · ${b.eliminato_motivo}` : ""}</div>
                    </div>
                    <Button size="sm" variant="outline" onClick={() => restore(b.id)} data-testid={`buste-restore-${b.id}`}><RotateCcw size={14} className="mr-1.5" /> Ripristina</Button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
